import { defineStore } from 'pinia'
import stageServices from '@/api/services/stagesServices.js'
import { useAuthStore } from '@/stores/authStore.js'
import { ref } from 'vue'

export const useStageStore = defineStore('stageStore', () => {
  const stageConfigs = ref([])

  const getStageConfigs = async () => {
    const authStore = useAuthStore()
    const token = authStore.authData.token
    const stageConfigsRes = await stageServices.getAuthArtistStageConfigs(token)

    stageConfigs.value = [...stageConfigsRes.data.memberships]
  }

  return {
    stageConfigs,
    getStageConfigs
  }
})
